import { render, staticRenderFns } from "./HomeTab.vue?vue&type=template&id=25063ac2"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports